import { buildSectionListPresentation } from "../renderers/sectionListPresenter";
import { scrollToPanelElement } from "../../components/sectionScroll";

// セクション一覧表示とチップ遷移をまとめる service です。
export function createSectionNavigationService(deps) {
    const {
        kakouShijiKubun,
        currentSampleSectionDefs,
        currentNormalSectionDefs,
        orderSectionsByPanel,
        showSections,
        sectionChipTargetIds,
        sectionChipLabelMap,
        renderSection,
        renderItemGroupTabBar,
        renderItemGroupScopeHeader,
        isEmpty,
        setCollapsedSections,
        sectionRefs,
        EntrybodyRef
    } = deps;

    // 画面上部のセクション一覧とチップ表示情報を組み立てます。
    function buildCurrentSectionListPresentation() {
        return buildSectionListPresentation({
            kakouShijiKubun,
            currentSampleSectionDefs,
            currentNormalSectionDefs,
            orderSectionsByPanel,
            showSections,
            sectionChipTargetIds,
            sectionChipLabelMap,
            renderSection,
            renderItemGroupTabBar,
            renderItemGroupScopeHeader,
            isEmpty
        });
    }

    // 指定セクションへスクロール移動します。
    function scrollToSection(sectionId) {
        setCollapsedSections((prev) => ({ ...prev, [sectionId]: false }));
        const elem = sectionRefs.current[sectionId];
        if (isEmpty(elem)) return;
        // 実際にスクロールしている側(コンテナ/ウィンドウ)を判定して移動する共通処理。
        scrollToPanelElement(EntrybodyRef.current, elem);
    }

    return {
        buildCurrentSectionListPresentation,
        scrollToSection
    };
}
